import { createClient } from "@/shared/urql/urql";
import {
  VerifyEmailDocument,
  type VerifyEmailMutationVariables,
} from "@/shared/generated/graphql";

export const verifyEmail = async ({
  email,
  token,
  password,
}: VerifyEmailMutationVariables) => {
  const urqlClient = createClient();
  const { error, data } = await urqlClient
    .mutation(VerifyEmailDocument, { email, token, password })
    .toPromise();
  if (error || data?.verifyEmail.errors.length !== 0) throw error;
  return data?.verifyEmail.passwordSet;
};
